import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { getFlattenedPermissionName, NavigationGuard, NavigationPermission } from '@skykick/core';
import { Products } from '../core/models/ProductType';

export const ProductNavigationGuard : CanActivateFn = (
  route: ActivatedRouteSnapshot, state
) => {
    const product = route.params['product'];
    const productNavigationArea = Products.find(x => x.name === product).navigationArea
    const dynamicData = {
      mandatoryPermissions: [getFlattenedPermissionName(productNavigationArea, NavigationPermission.FullAccess)],
      permissionAbsentRedirect: 'settings/notifications/general',
      isPrimaryNavigation: false
    };

    const newRoute = {
      ...route,
      data: {
        ...route.data,
        navigationGuardData: dynamicData
      }
    } as unknown as ActivatedRouteSnapshot;

    return NavigationGuard(newRoute, state);
};